var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackPlus = function SvgBlackPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3C3A",
    d: "M10 0c-.597 0-1.081.484-1.081 1.081V8.92H1.08a1.081 1.081 0 1 0 0 2.162H8.92v7.838a1.081 1.081 0 1 0 2.162 0V11.08h7.838a1.081 1.081 0 1 0 0-2.162H11.08V1.081C11.081.484 10.597 0 10 0Z"
  })));
};
export default SvgBlackPlus;